import WatsonApi from "../backends/WatsonApi";
import { refreshClientRouter } from "../actions/refreshClientRouter";

export function useCreateContentItem() {
  async function handleSave(
    contentItem,
    organization,
    post_to_facebook: boolean,
  ) {
    const client = await WatsonApi();
    await client.apis.organizations.organizations_content_items_create({
      organization_pk: organization.id,
      post_to_facebook: post_to_facebook,
      data: contentItem,
    });
    await refreshClientRouter();
  }

  return { handleSave };
}
